var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenLinkSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#999999;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 400,
    height: 400
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.4,212.3l-17.6,17.6c-1.8,1.8-4.8,1.8-6.6,0s-1.8-4.8,0-6.6l15.9-15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206,187.4l17.2-17.2c1.8-1.8,4.8-1.8,6.6,0s1.8,4.8,0,6.6l-15.5,15.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 182.1,
    y: 143.5,
    className: "st2",
    width: 5.4,
    height: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 181.1,
    className: "st2",
    width: 21.5,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.2,
    y: 152.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -67.1866 163.6171)",
    className: "st2",
    width: 5.4,
    height: 21.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 211.5,
    y: 229,
    className: "st2",
    width: 5.4,
    height: 21.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 207.5,
    className: "st2",
    width: 21.5,
    height: 5.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.4,
    y: 220.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -94.549 233.9184)",
    className: "st2",
    width: 5.4,
    height: 21.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.8,210.9c-10.2-1.9-21.2,1.1-29.1,9l-13.2,13.2c-12.8,12.8-12.8,33.6,0,46.4c12.8,12.8,33.6,12.8,46.4,0 l13.2-13.2c7.9-7.9,10.9-18.8,9-29.1c0.3-0.3,0.6-0.4,0.9-0.7l6.8-6.8c4.9,14.7,1.6,31.5-10.1,43.2l-13.2,13.2 c-16.4,16.4-43.1,16.4-59.6,0c-16.4-16.5-16.4-43.2,0-59.6l13.2-13.2c11.7-11.7,28.5-15,43.2-10.1l-6.8,6.8 C163.2,210.3,163,210.6,162.8,210.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.2,173.4l-13.2,13.2c-11.7,11.7-28.5,15-43.2,10.1l6.8-6.8c0.3-0.3,0.5-0.6,0.7-0.9 c10.2,1.9,21.2-1.1,29.1-9l13.2-13.2c12.8-12.8,12.8-33.6,0-46.4c-12.8-12.8-33.6-12.8-46.4,0l-13.2,13.2 c-7.9,7.9-10.9,18.8-9,29.1c-0.3,0.3-0.6,0.4-0.9,0.7l-6.8,6.8c-4.9-14.7-1.6-31.5,10.1-43.2l13.2-13.2c16.4-16.4,43.1-16.4,59.6,0 C302.6,130.3,302.6,157,286.2,173.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLinkSmall);
export default __webpack_public_path__ + "static/media/broken_link_small.3946dfebd9a7405a6d50d8ec1ec0d50e.svg";
export { ForwardRef as ReactComponent };